import * as React from 'react';

const LifePreserverSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M22 12c0-2.6-1-4.9-2.6-6.7l.6-.6-.7-.7-.6.6C16.9 3 14.6 2 12 2S7.1 3 5.3 4.6L4.7 4l-.7.7.6.6C3 7.1 2 9.4 2 12s1 4.9 2.6 6.7l-.5.5.7.7.5-.5C7.1 21 9.4 22 12 22s4.9-1 6.7-2.6l.5.5.7-.7-.5-.5C21 16.9 22 14.6 22 12zm-1 0c0 2.3-.9 4.4-2.3 6l-3.3-3.3c.6-.7.9-1.7.9-2.7s-.3-2-.9-2.7L18.7 6c1.4 1.6 2.3 3.7 2.3 6zm-6.7 1.6l-.7.7.4.4c-.6.4-1.3.7-2.1.7-.7 0-1.4-.2-2-.6l.5-.5-.7-.7-.5.5c-.4-.6-.7-1.3-.7-2.1s.3-1.5.7-2.1l.5.5.7-.7-.5-.5c.6-.4 1.2-.6 2-.6s1.5.3 2.1.7l-.4.4.7.7.4-.4c.4.6.6 1.2.6 2s-.2 1.4-.6 2l-.4-.4zM12 3c2.3 0 4.4.9 6 2.3l-3.3 3.3c-.8-.6-1.7-1-2.8-1-1 0-2 .3-2.7.9L6 5.3C7.6 3.9 9.7 3 12 3zm-9 9c0-2.3.9-4.4 2.3-6l3.2 3.2c-.6.8-1 1.7-1 2.8s.4 2 1 2.8L5.3 18C3.9 16.4 3 14.3 3 12zm9 9c-2.3 0-4.4-.9-6-2.3l3.2-3.2c.7.6 1.7.9 2.7.9 1.1 0 2-.4 2.8-1l3.3 3.3c-1.6 1.4-3.7 2.3-6 2.3z"
        />
    </svg>
);

LifePreserverSvg.displayName = 'LifePreserverSvg';
export default LifePreserverSvg;
